/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const investmentNeedRoundHistoryDtoSchema = z.object({
  date: z.optional(z.string()),
  round: z.optional(z.string()),
  amount: z.string().nullish(),
});
